"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _swarmplot = require("cccisd-nivo/swarmplot");
var _util = require("./util.js");
var _style = _interopRequireDefault(require("./style.css"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var GraphQLSwarmChart = function GraphQLSwarmChart(props) {
  var processData = function processData() {
    var data = props.data,
      labelPath = props.labelPath,
      valuePath = props.valuePath,
      volumePath = props.volumePath,
      groupLabel = props.groupLabel,
      maxLabelLength = props.maxLabelLength,
      labelTailLength = props.labelTailLength,
      rollupAbove = props.rollupAbove,
      ignoreValues = props.ignoreValues;
    var rollupAboveLabel = props.rollupAboveLabel;
    if (rollupAboveLabel === '') {
      rollupAboveLabel = '> ' + rollupAbove;
    }
    var rollupCount = 0;
    var chartData = data.filter(function (row) {
      var rowValue = (0, _util.dotIndex)(valuePath, row);
      var rowVolume = (0, _util.dotIndex)(volumePath, row);
      if (ignoreValues && ignoreValues.includes(rowValue)) {
        return false;
      }
      if (rowValue > rollupAbove) {
        rollupCount += volumePath === '' ? rowValue : rowVolume;
        return false;
      }
      return true;
    }).map(function (row) {
      var rowLabel = (0, _util.shorten)((0, _util.dotIndex)(labelPath, row), maxLabelLength, labelTailLength);
      var rowValue = (0, _util.dotIndex)(valuePath, row);
      var rowVolume = volumePath === '' ? 5 : (0, _util.dotIndex)(volumePath, row);
      return {
        id: rowLabel,
        value: rowValue,
        group: groupLabel,
        volume: rowVolume
      };
    });
    if (rollupCount > 0) {
      chartData.push({
        id: rollupAboveLabel,
        value: rollupAbove,
        group: groupLabel,
        volume: volumePath === '' ? 5 : rollupCount
      });
    }
    return chartData;
  };
  var swarmTooltip = function swarmTooltip() {
    var tooltipLabel = props.tooltipLabel,
      tooltipLabelPlural = props.tooltipLabelPlural,
      tooltipValue = props.tooltipValue,
      tooltipValuePlural = props.tooltipValuePlural;
    return function (_ref) {
      var node = _ref.node;
      var label = node.label === 1 || node.label === '1' ? tooltipLabel : tooltipLabelPlural;
      var value = node.data.volume === 1 ? tooltipValue : tooltipValuePlural;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tooltip
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].tooltipInner
      }, /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: node.color
        }
      }, node.label, label, ":"), ' ', node.data.volume, value)));
    };
  };
  var renderTotal = function renderTotal(chartData) {
    var totalLabel = props.totalLabel,
      volumePath = props.volumePath,
      showTotal = props.showTotal,
      data = props.data;
    var chartTotal = 0;
    if (volumePath) {
      chartTotal = chartData.reduce((0, _util.totalReducer)('volume'), 0);
    } else {
      chartTotal = chartData.length;
    }
    if (!showTotal) {
      return null;
    }
    var skippedTotal = (0, _get2["default"])((0, _find2["default"])(data, ['value', null]), 'valueCount', 0);
    return /*#__PURE__*/_react["default"].createElement("h5", {
      className: _style["default"].total
    }, totalLabel, ":\xA0", chartTotal, skippedTotal > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), "Skipped:\xA0", skippedTotal));
  };
  var renderSwarm = function renderSwarm(chartData) {
    var width = props.width,
      height = props.height,
      nivo = props.nivo,
      groupLabel = props.groupLabel,
      volumePath = props.volumePath;
    var wrapperProps = {
      width: width,
      height: height
    };
    var defaultProps = {
      margin: {
        top: 150,
        right: 100,
        bottom: 150,
        left: 100
      },
      colors: {
        scheme: 'category10'
      },
      groups: [groupLabel],
      layout: 'horizontal',
      size: 5
    };
    if (volumePath) {
      defaultProps.tooltip = swarmTooltip();
      defaultProps.size = function (node) {
        return Math.max(5, 5 * Math.sqrt(node.volume));
      };
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: wrapperProps
    }, renderTotal(chartData), /*#__PURE__*/_react["default"].createElement(_swarmplot.ResponsiveSwarmPlot, _extends({}, defaultProps, nivo, {
      data: chartData
    })));
  };
  var chartData = processData();
  if (chartData === null) {
    return null;
  }
  return renderSwarm(chartData);
};
GraphQLSwarmChart.propTypes = {
  data: _propTypes["default"].array.isRequired,
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  labelPath: _propTypes["default"].string,
  valuePath: _propTypes["default"].string,
  groupLabel: _propTypes["default"].string,
  maxLabelLength: _propTypes["default"].number,
  labelTailLength: _propTypes["default"].number,
  tooltipLabel: _propTypes["default"].string,
  tooltipLabelPlural: _propTypes["default"].string,
  tooltipValue: _propTypes["default"].string,
  tooltipValuePlural: _propTypes["default"].string,
  rollupAbove: _propTypes["default"].number,
  rollupAboveLabel: _propTypes["default"].string,
  showTotal: _propTypes["default"].bool,
  totalLabel: _propTypes["default"].string,
  nivo: _propTypes["default"].object,
  ignoreValues: _propTypes["default"].array
};
GraphQLSwarmChart.defaultProps = {
  width: '100%',
  height: '600px',
  labelPath: 'value',
  valuePath: 'valueCount',
  volumePath: '',
  groupLabel: 'data',
  maxLabelLength: 40,
  labelTailLength: 10,
  rollupAbove: 999999999,
  rollupAboveLabel: '',
  totalLabel: 'Total',
  showFrequencyTable: false,
  nivo: {},
  ignoreValues: []
};
var _default = exports["default"] = GraphQLSwarmChart;